import React from 'react';
import { useNavigate } from 'react-router-dom';
import useOperationalStore from '../../platform/store/useOperationalStore';
import rekonLogo from '../../Assets/Rekon name.png';
import './MobileLauncher.css';

const VIEWS = [
  {
    id: 'flow',
    path: '/flow',
    label: 'Flow',
    sub: 'Pipeline board',
    accent: '#f59e0b',
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/>
        <line x1="7" y1="12" x2="10" y2="12"/><line x1="14" y1="12" x2="17" y2="12"/>
      </svg>
    ),
  },
  {
    id: 'jobs',
    path: '/ro-list',
    label: 'Jobs',
    sub: 'All repair orders',
    accent: '#3b82f6',
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/>
        <line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/>
      </svg>
    ),
  },
  {
    id: 'timeline',
    path: '/timeline',
    label: 'Timeline',
    sub: 'Stage history',
    accent: '#8b5cf6',
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/>
        <circle cx="7" cy="6" r="2" fill="currentColor"/><circle cx="14" cy="12" r="2" fill="currentColor"/><circle cx="10" cy="18" r="2" fill="currentColor"/>
      </svg>
    ),
  },
  {
    id: 'command',
    path: '/command',
    label: 'Command',
    sub: 'Shop overview',
    accent: '#22c55e',
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
      </svg>
    ),
  },
  {
    id: 'road-service',
    path: '/road-service',
    label: 'Road Service',
    sub: 'Dispatch map',
    accent: '#06b6d4',
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 19l4-14h8l4 14"/><path d="M12 5v3m0 4v3m0 4v0"/>
      </svg>
    ),
  },
  {
    id: 'priority',
    path: '/priority',
    label: 'Priority',
    sub: 'Money & urgency',
    accent: '#f97316',
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><path d="M12 8v4l2 2"/>
      </svg>
    ),
  },
  {
    id: 'schedule',
    path: '/schedule',
    label: 'Schedule',
    sub: 'Appointments',
    accent: '#ef4444',
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="17" rx="2"/>
        <line x1="16" y1="2" x2="16" y2="6"/>
        <line x1="8" y1="2" x2="8" y2="6"/>
        <line x1="3" y1="10" x2="21" y2="10"/>
      </svg>
    ),
  },
];

export default function MobileLauncher({ onAddTruck, onManageTeam }) {
  const navigate      = useNavigate();
  const trucks        = useOperationalStore(s => s.trucks);
  const getShopHealth = useOperationalStore(s => s.getShopHealth);

  const active    = trucks.filter(t => !['completed', 'voided'].includes(t.status)).length;
  const critical  = trucks.filter(t => t.isHardDown).length;
  const health    = getShopHealth();
  const healthColor = health >= 80 ? '#22c55e' : health >= 55 ? '#f59e0b' : '#ef4444';

  return (
    <div className="ml-root">
      <div className="ml-top">
        <img className="ml-logo" src={rekonLogo} alt="REKON" />
        <div className="ml-stats">
          <span className="ml-health-dot" style={{ background: healthColor }} />
          <span className="ml-stat">{active} active</span>
          {critical > 0 && (
            <>
              <span className="ml-stat-sep">·</span>
              <span className="ml-stat-alert">{critical} critical</span>
            </>
          )}
          <span className="ml-stat-sep">·</span>
          <span className="ml-health-score" style={{ color: healthColor }}>{health}/100</span>
        </div>
      </div>

      <div className="ml-grid">
        {VIEWS.map(v => (
          <button key={v.id} className="ml-tile" onClick={() => navigate(v.path)}>
            <span className="ml-tile-accent" style={{ background: v.accent }} />
            <span className="ml-tile-icon">{v.icon}</span>
            <span className="ml-tile-label">{v.label}</span>
            <span className="ml-tile-sub">{v.sub}</span>
          </button>
        ))}
      </div>

      <div className="ml-actions">
        <button className="ml-add-btn" onClick={onAddTruck}>
          + Add Service Unit
        </button>
        <button className="ml-team-btn" onClick={onManageTeam}>
          Manage Team
        </button>
      </div>
    </div>
  );
}
